
<template>
  <div>
    <div class="agInputGroup agInputGroupCentered">
      <label>Connection (Geometry Server):</label>
      <b-form-select
        class="agLargeInput"
        v-model="geoInput.connection"
        :options="geoConnections"
        :disabled="disableUI">
      </b-form-select>
    </div>
    <ag-fields-selector
      ref="fieldsSelector"
      :node="geoInput.config"
      :disableUI="disableUI"
      :connections="connections"
      @refreshedSchemas="refreshedSchemas"
      @connectionChanged="connectionChanged"
      @layerChanged="layerChanged">
    </ag-fields-selector>
    <ag-sub-input
      ref="wClause"
      :initText="geoInput.config.wClause"
      :workflow="workflow"
      :size="'md'"
      :prepend="'Where'"
      :appendButton="true"
      :buttonText="'Test'"
      :disabled="disableUI"
      @buttonClick="testWClause_click"
    ></ag-sub-input>
    <label
      id="agGetNearest-testMessage"
      :class="testMessageClass"
      @click="testMessage_click"
    >{{testMessage}}</label>
    <div class="agInputGroupCentered">
      <div class="agInputGroup agInputGroupInline">
        <label>Input For X &amp; Y:</label>
        <b-form-select
          class="agLargeInput"
          v-model="geoInput.config.input"
          :options="inputs"
          :disabled="disableUI"
          @change="inputField_change"
        ></b-form-select>
      </div>
      <div class="agInputGroup agInputGroupInline">
        <input
          type="checkbox"
          v-model="geoInput.config.useGeometry"
          :disabled="disableUI"
          @change="useGeometryCheckbox_change"
        />
        <label>Use geometry</label>
      </div>
    </div>
    <div v-if="showXYFields">
      <div class="agInputGroupCentered">
        <div class="agInputGroup agInputGroupInline">
          <label>X Field:</label>
          <b-form-select
            class="agMediumInput"
            v-model="geoInput.config.xField"
            :options="xyFields"
            :disabled="disableUI || xyFields.length == 0"
          ></b-form-select>
        </div>
        <div class="agInputGroup agInputGroupInline">
          <label>Y Field:</label>
          <b-form-select
            class="agMediumInput"
            v-model="geoInput.config.yField"
            :options="xyFields"
            :disabled="disableUI || xyFields.length == 0"
          ></b-form-select>
        </div>
        <div class="agInputGroup agInputGroupInline">
          <label>Spatial Reference (WKID):</label>
          <b-input
            class="agSmallInput"
            v-model="geoInput.config.spatialRef"
            type="number"
            :disabled="disableUI">
          </b-input>
        </div>
      </div>
      
    </div>
    <div class="agInputGroupCentered">
      <div class="agInputGroup agInputGroupInline">
        <label>Buffer:</label>
        <b-input
          class="agSmallInput"
          v-model="geoInput.config.buffer"
          type="number"
          :disabled="disableUI"
        ></b-input>
      </div>
      <div class="agInputGroup agInputGroupInline">
        <label>Units:</label>
        <b-form-select
          class="agSmallInput"
          v-model="geoInput.config.units"
          :options="units"
          :disabled="disableUI"
        ></b-form-select>
      </div>
    </div>
  </div>
</template>






<script>

// components
import SubInput from "comp/ui/SubInput";
import FieldsSelector from "comp/ui/FieldsSelector"

// modules
import Server from "src/server";
import { EventBus } from "src/eventBus";

export default {
  name: "ag-geoInput-getNearest",
  components: {
    "ag-sub-input": SubInput,
    "ag-fields-selector": FieldsSelector
  },
  props: {
    disableUI: Boolean,
    workflow: Object,
    geoInput: Object
  },
  data() {
    return {
      testMessage: "",
      testMessageClass: "",
      testRecords: [],
      xyFields: [],
      showXYFields: true,
      units: [
        {value: 9003, text: "Feet"},
        {value: 9001, text: "Meters"},
        {value: 9035, text: "Miles"},
        {value: 9036, text: "Kilometers"},
        {value: 109002, text: "Yards"}
      ]
    };
  },
  computed: {

    geoConnections() {
        var connections = [];
        var geoConnections = this.$store.getters["connStore/getGeometryConns"];
        for (var i = 0; i < geoConnections.length; i++) {
            var conn = geoConnections[i];
            var connItem = {value: conn, text: conn.name};
            connections.push(connItem);

            if(this.geoInput.connection && conn._id == this.geoInput.connection._id) {
            this.geoInput.connection = conn;
            }
      }
      return connections;
    },

    connections() {
      var connections = [];
      var gisConnections = this.$store.getters["connStore/getGISConns"];
      for (var i = 0; i < gisConnections.length; i++) {
        var conn = gisConnections[i];
        var connItem = { value: conn, text: conn.name };
        connections.push(connItem);

        if (
          this.geoInput.config.connection &&
          conn._id == this.geoInput.config.connection._id
        ) {
          this.geoInput.config.connection = conn;
        }
      }
      return connections;
    },

    inputs() {
      var inputs = [];
      for (var i = 0; i < this.workflow.inputs.length; i++) {
        var input = this.workflow.inputs[i];
        var name = input.shortname;
        if (input.name) {
          name += ": " + input.name;
        }
        inputs.push({ value: input.shortname, text: name });
      }

      for (var i = 0; i < this.workflow.geoInputs.length; i++) {
        var input = this.workflow.geoInputs[i];
        if (input.shortname == this.geoInput.shortname) continue;
        var name = input.shortname;
        if (input.name) {
          name += ": " + input.name;
        }
        inputs.push({ value: input.shortname, text: name });
      }
      return inputs;
    },

    filteredFields() {
      if (!this.fieldSearchText) return this.fields;

      var filteredFields = this.fields.filter(
        a =>
          (a.field &&
            a.field.toLowerCase().indexOf(this.fieldSearchText.toLowerCase()) >
              -1) ||
          (a.alias &&
            a.alias.toLowerCase().indexOf(this.fieldSearchText.toLowerCase()) >
              -1)
      );
      return filteredFields;
    }
  },
  watch: {},

  created() {},

  mounted() {},

  methods: {
    
    // UI Events

    useGeometryCheckbox_change() {
      if (this.geoInput.config.useGeometry) this.showXYFields = false;
      else this.showXYFields = true;
    },

    inputField_change() {
      this.setXYFields();
    },

    async testWClause_click() {
      try {
        this.testRecords = [];
        this.testMessage = "";

        if (!this.geoInput.connection) {
          this.testRecords = [];
          this.testMessage = "A geometry server connection must be selected";
          this.testMessageClass = "agModal-errorMessage";
          return;
        }
        if (!this.geoInput.config.connection) {
          this.testRecords = [];
          this.testMessage = "A featuresconnection must be selected";
          this.testMessageClass = "agModal-errorMessage";
          return;
        }
        if (this.geoInput.config.layer == null) {
          this.testRecords = [];
          this.testMessage = "A layer/object must be selected";
          this.testMessageClass = "agModal-errorMessage";
          return;
        }
        var fields = [];
        for (var i = 0; i < this.fields.length; i++) {
          var field = this.fields[i];
          if (field.enabled) {
            fields.push(field.field);
          }
        }

        var wClause = this.$refs["wClause"].text;
        var result = await Server.post("getRecords", {
          connection: this.geoInput.config.connection._id,
          layer: this.geoInput.config.layer,
          fields: fields,
          wClause: wClause
        }).promise;
        if (!result.data.success) throw result.data.error;
        this.testRecords = result.data.records;
        this.testMessage = `Success: ${this.testRecords.length} record(s) found`;
        this.testMessageClass = "agModal-successMessage";
      } catch (e) {
        this.testRecords = [];
        this.testMessage = e.toString();
        this.testMessageClass = "agModal-errorMessage";
      }
    },

    testMessage_click() {
      if (this.testMessageClass.indexOf("success") <= 0) return;

      EventBus.$emit("showAlert", {
        title: `${this.testRecords.length} Record(s)`,
        message: JSON.stringify(this.testRecords),
        type: "default"
      });
    },

    // emitted Events

    refreshedSchemas() {

    },

    connectionChanged() {
      
    },

    layerChanged() {
    },


    // other

    reset() {

      // init config object if it's empty
      if (Object.keys(this.geoInput.config).length == 0) {
        this.geoInput.config = {
          connection: null,
          layer: null,
          fields: [],
          input: null,
          useGeometry: false,
          xField: null,
          yField: null,
          spatialRef: null,
          buffer: null,
          units: null,
          wClause: ""
        };
      }
      this.fieldSearchText = "";
      this.showXYFields = !this.geoInput.config.useGeometry;

      this.setXYFields();
      var self = this;
      setTimeout(() => {
        self.$refs.fieldsSelector.reset();
      }, 250);
    },

    prepareForSave() {
      // build fields w/ checked fields
      this.geoInput.config.fields = [];
      for (var i = 0; i < this.$refs.fieldsSelector.fields.length; i++) {
        var field = this.$refs.fieldsSelector.fields[i];
        if (field.enabled) {
          this.geoInput.config.fields.push(field.field);
        }
      }

      // manually pull wClause from subInput component
      this.geoInput.config.wClause = this.$refs["wClause"].text;
    },

    setXYFields() {
      this.xyFields = [];
      if (!this.geoInput.config.input) return;

      for (var i = 0; i < this.workflow.inputs.length; i++) {
        var input = this.workflow.inputs[i];
        if (input.shortname == this.geoInput.config.input) {
          if (input.fields) this.xyFields = input.fields;
          return;
        }
      }
    }
  }
};
</script>






<style scoped lang="css">
#agGetNearest-fieldsTable {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 155px);
  height: 175px;
  margin: 5px 0px 0px 100px;
  overflow: auto;
  border-collapse: collapse;
}

#agGetNearest-fieldsTableSpinner {
  position: relative;
  left: -500px;
  top: 75px;
}

#agGetNearest-fieldSearch {
  width: calc(100% - 200px);
}

#agGetNearest-testMessage {
  position: relative;
  width: 100%;
  top: -5px;
  text-align: center;
}

#agGetNearest-testMessage.agModal-successMessage:hover {
  cursor: pointer;
  text-decoration: underline;
}

#agGetNearest-testMessage.agModal-successMessage:active {
  opacity: 0.5;
}
</style>

<style lang="css">

#agGetNearest-fieldsTable .agGetNearest-fieldsTableCell {
  min-width: 125px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/nodes/geoInputs/NearestFeature.vue